import Swiper from 'swiper/bundle';

(function ($) {
    $(document).ready(function () {

        let swiper = new Swiper(".section-home-top-banner .slider-home-top-banner", {
            slidesPerView: 1,
            effect: "fade",
            loop: true,
            speed: 1000,
            fadeEffect: {
                crossFade: true,
            },
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
            },
            navigation: {
                nextEl: ".section-home-top-banner .swiper-button-next",
                prevEl: ".section-home-top-banner .swiper-button-prev",
            }
        });

        //update buttons color
        const updateNavButtonsColor = () => {
            const activeSlide = document.querySelector('.swiper-slide-active');
            const newColor = activeSlide.getAttribute('data-color');
            const buttons = document.querySelectorAll('.swiper-button');

            buttons.forEach(button => {
                button.style.backgroundColor = newColor;
            });
        };

        //hide inactive (faded out) slides from assistive tech and keyboard focus
        const updateSlidesAccessibility = () => {
            swiper.slides.forEach((slide, index) => {
                const isActive = index === swiper.activeIndex;

                slide.toggleAttribute('inert', !isActive);
                slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
            });
        };

        swiper.on('transitionStart', updateNavButtonsColor);
        swiper.on('slideChange', updateSlidesAccessibility);

        updateNavButtonsColor();
        updateSlidesAccessibility();
    });

})(jQuery);


